import { useState } from "react"
import { useTranslation } from "react-i18next"
import { toast } from "sonner"
import { MarketingLeadsExportLeads } from "@/shared/api/generated/marketing-leads/marketing-leads"
import { selectLeadsExportData } from "./api-selectors"

type ExportFilters = Parameters<typeof MarketingLeadsExportLeads>[0]

export function useLeadsExport(filters: ExportFilters) {
	const { t } = useTranslation()
	const [isExporting, setIsExporting] = useState(false)

	const exportLeads = async () => {
		setIsExporting(true)
		try {
			const blob = selectLeadsExportData(
				await MarketingLeadsExportLeads(filters),
			)
			const url = URL.createObjectURL(blob)
			const link = document.createElement("a")
			link.href = url
			link.download = `leads_${new Date().toISOString().slice(0, 16).replace("T", "_").replace(":", "-")}.xlsx`
			link.click()
			URL.revokeObjectURL(url)
		} catch {
			toast.error(t("leads.notifications.exportError"))
		} finally {
			setIsExporting(false)
		}
	}

	return { exportLeads, isExporting }
}
